module.exports = __webpack_public_path__ + "img/itatlogowide.4af284e7.png";